import { createRoot } from 'react-dom/client';
import { LoginService } from '@ey/mfe-ui-core';
import { MsalProvider } from '@azure/msal-react';
import { Auth0Provider } from '@auth0/auth0-react';
import { QueryClient, QueryClientProvider } from '@tanstack/react-query';

import { Router } from './helpers/Routing';

const {
  REACT_APP_CLIENT_ID,
  REACT_APP_TENANT_ID,
  REACT_APP_AUTHORITY_URL,
  REACT_APP_AUTH0_CLIENT_ID,
  REACT_APP_AUTH0_AUTHORITY_URL,
  REACT_APP_HOME_URL
} = process.env;

console.log(REACT_APP_HOME_URL);
const msalRedirectURL = REACT_APP_HOME_URL + '/login/';
console.log(msalRedirectURL);
const queryClient = new QueryClient();

const renderer = () => {
  const root = createRoot(document.getElementById('app')!);

  const msalConfig = {
    clientId: REACT_APP_CLIENT_ID!,
    tenantId: REACT_APP_TENANT_ID!,
    authorityUrl: REACT_APP_AUTHORITY_URL!,
    redirectUrl: msalRedirectURL,
    postLogoutRedirectUri: msalRedirectURL,
    storeAuthStateInCookie: false
  };
  const loginService = new LoginService();
  const msalInstance = loginService.generateMSALInstance(msalConfig);

  msalInstance.initialize().then(() => {
    root.render(
      <QueryClientProvider client={queryClient}>
      <MsalProvider instance={msalInstance}>
        <Auth0Provider
          domain={REACT_APP_AUTH0_AUTHORITY_URL!}
          clientId={REACT_APP_AUTH0_CLIENT_ID!}
          cacheLocation="localstorage"
          authorizationParams={{
            redirect_uri: msalRedirectURL
          }}
        >
          <Router />
        </Auth0Provider>
      </MsalProvider>
      </QueryClientProvider>
    );
  });
};

export { renderer as default };
